module.exports = __webpack_public_path__ + "img/recolumn_example11.42ceca8e.png";